import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { SurveyAnswerRepositoryImpl } from "../../data/repository/survey_answer_repository_impl";
import { SurveyInterface } from "../interfaces/survey_interface";

interface useModifySurveyComment {
    surveyId: string;
    comment: string;
}

export const useModifySurveyComment = () => {
    const repository = new SurveyAnswerRepositoryImpl();
    const queryClient = useQueryClient();

    return useMutation<string | null, AxiosError, useModifySurveyComment>({
        mutationFn: (data: useModifySurveyComment) => repository.modifySurveyComment(data.comment, data.surveyId),
        onSuccess: (_data, { surveyId, comment }) => {
            queryClient.setQueryData<SurveyInterface | null>(['survey', surveyId], (old) =>
                old ? { ...old, surveyComment: comment } : old
            );
            queryClient.invalidateQueries({ queryKey: ['surveysList'] });
        },
    });
};
